import React from "react"
import { Row, Col } from "react-styled-flexboxgrid"

import { TABLE_SIZES_WITHOUT_NAME } from "./tableSizesWithoutName"
import Spacer from "~/components/Spacer"
import { USER_INFO_SEARCH_OPTIONS_COMPONENTS } from "../Elements/searchConfig"

const UserInfoRowWithoutName = () => {
  const ColumnOneComponent = USER_INFO_SEARCH_OPTIONS_COMPONENTS.email
  const ColumnTwoComponent = USER_INFO_SEARCH_OPTIONS_COMPONENTS.phoneNumber
  return (
    <Row>
      <Col {...TABLE_SIZES_WITHOUT_NAME.email}>
        <Spacer mobile={15} desktop={15} />
        <ColumnOneComponent autofocus />
      </Col>
      <Col {...TABLE_SIZES_WITHOUT_NAME.phoneNumber}>
        <Spacer mobile={15} desktop={15} />
        <ColumnTwoComponent />
      </Col>
      <Col {...TABLE_SIZES_WITHOUT_NAME.nothing} />
    </Row>
  )
}

export default UserInfoRowWithoutName
